export default "__VITE_ASSET__e64a39e8__"